<template>
  <nav
    class="navbar fixed-top navbar-expand-lg navbar-light"
    style="background-color: #e8f1ff;"
  >
    <div class="container">
      <router-link to="/" class="navbar-brand">
        <img
          src="@/assets/logo.svg"
          width="30"
          height="30"
          class="d-inline-block align-top"
          alt=""
        />
        LearnNow
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">
          <li v-if="isLoggedIn" class="nav-item ">
            <router-link to="/courses" class="nav-link">Courses</router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item">
            <router-link to="/collections" class="nav-link">
              Collections
            </router-link>
          </li>
          <li v-if="isLoggedIn" class="nav-item mr-3">
            <router-link to="/course_manager" class="nav-link">
              Course Manager
            </router-link>
          </li>
          <li class="nav-item">
            <button
              v-if="isLoggedIn"
              @click="logOut"
              class="btn btn-outline-danger my-2 my-sm-0"
              type="submit"
            >
              Log Out
            </button>
            <router-link
              v-else
              to="/register"
              class="btn btn-outline-primary my-2 my-sm-0"
              type="submit"
            >
              Sign Up / Sign In
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Navbar',
  data() {
    return {
      isLoggedIn: false,
      currentUser: false
    }
  },
  created() {
    if (firebase.auth().currentUser) {
      this.isLoggedIn = true
      this.currentUser = firebase.auth().currentUser.email
    }
  },
  methods: {
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.go({ path: 'this.$router.path' })
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
